<template>
  <div v-if="isActive" class="relative bg-gray-200 py-4">
    <div class="container">
      <div class="mx-auto aspect-[970/200] max-w-[900px]">
        <NuxtLink :to="bannerLinkWithUTM(bannerLink)" target="_blank">
          <NuxtImg
            provider="sanity"
            v-if="bannerImage"
            :src="bannerImage.asset?._ref"
            alt="Top Banner"
            class="h-full w-full object-cover"
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getAll } from "~/groq/banners"
import type { Banners } from "~/@types/schema"

const { data: banners } = await useSanityQuery<Banners>(getAll())

const topBanner = banners.value?.banner
const isActive = computed(() => topBanner?.isActive)
const bannerLink = computed(() => topBanner?.link || "#")
const bannerImage = computed(() => topBanner?.image)

const bannerLinkWithUTM = (link: string): string => {
  return linkWithUTM(link, "calibre_careers", "banner", "top_banner")
}
</script>
